import React, { FC } from 'react'
import { ProductWrapper, Typography } from '@dg-shared'
import { useTranslate } from '../../../hooks/shared'
import { makeStyles } from 'tss-react/mui'
import withV4IndexPriority from '../../../styles/withV4IndexPriority'
import { Theme } from '@mui/material/styles'
import { AUTH_AGENT, AUTH_CHOICE, REGULAR } from '../../../constants'
import CustomSwitch from '../../../components/shared/layouts/CustomSwitch'
import { TRANSLATIONS as T } from '../../../constants/translations-constants'
import { CustomClassName } from '../../../types/interface/styles.interface'
import { getDataComponentName } from '@dg-util'
import { PartnerName, ProductName } from '../../../types/interface/quote.interface'

export const useAuthStartegyText = makeStyles()((theme: Theme) =>
  withV4IndexPriority({
    paragraph: {
      marginBottom: theme.spacing(1),
      textAlign: 'start',
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
    },

    titleWrapper: {
      display: 'flex',
    },

    title: {
      lineHeight: '1.2 !important',
      fontSize: '28px !important',
      ...theme.brand.typography.overrides?.authTitle,
      marginBottom: theme.spacing(2),
      maxWidth: '325px',
    },

    subtitle: {
      marginBottom: theme.spacing(1),
      ...theme.brand.typography.overrides?.authSubtitle,
    },
  })
)

const AuthStrategyTitle: FC<CustomClassName> = ({}) => {
  const { classes } = useAuthStartegyText()
  const { t } = useTranslate(T.AUTH)

  return (
    <div data-componentname={getDataComponentName(__filename)}>
      <div className={classes.titleWrapper}>
        <Typography type='h1' className={classes.title}>
          {t('title')}
        </Typography>
      </div>
      <ProductWrapper partners={[PartnerName.circlek]} products={[ProductName.VEHICLE]}>
        <CustomSwitch showOn={[AUTH_CHOICE]}>
          <Typography color='headingSecondary' type='h3' className={classes.subtitle}>
            {t('subtitle')}
          </Typography>
        </CustomSwitch>
      </ProductWrapper>
      <ProductWrapper
        partners={[PartnerName.nord, PartnerName.instabank, PartnerName.coverme]}
        products={[ProductName.VEHICLE, ProductName.CONTENT, ProductName.TRAVEL]}
      >
        <CustomSwitch showOn={[AUTH_CHOICE, REGULAR, AUTH_AGENT]}>
          <Typography color='headingSecondary' type='h3' className={classes.subtitle}>
            {t('subtitle')}
          </Typography>
        </CustomSwitch>
      </ProductWrapper>
    </div>
  )
}

export default AuthStrategyTitle
